export default __webpack_public_path__ + "static/media/ballroom-bg.6435c83c.png";